// 3rd party imports
import * as React from 'react';

// bernie
import { Viewport, ViewSmall, ViewMedium } from 'bernie-view';
import { withLocalization, LocalizedText } from 'bernie-l10n';

// ui
import { UitkCard } from 'uitk-react-cards';
import {
  UitkLayoutFlex,
  UitkLayoutFlexItem,
  UitkLayoutFlexItemProps,
  UitkLayoutFlexProps,
} from 'uitk-react-layout-flex';
import { UitkSpacing } from 'uitk-react-spacing';
import { UitkHeading, UitkText } from 'uitk-react-text';
import { UitkList, UitkListItem } from 'uitk-react-list';

// components
import { AffiliateCTA } from '../affiliate-cta';
import { LocalizedComponentProps } from '@shared-ui/localization-context';

export interface BenefitsProps extends LocalizedComponentProps {
  locale?: string;
}

@withLocalization
export class Benefits extends React.Component<BenefitsProps> {
  public render() {
    const getContent = (
      direction: UitkLayoutFlexProps['direction'],
      minWidth: UitkLayoutFlexItemProps['minWidth'],
      maxWidth: UitkLayoutFlexItemProps['maxWidth'],
    ) => (
      <>
        <UitkHeading tag="h2" size={3}>
          <LocalizedText message="lp.affiliate.benefits.title" />
        </UitkHeading>
        <UitkLayoutFlex
          className={'all-y-padding-six'}
          space={'three'}
          direction={direction}
          justifyContent={'space-between'}
        >
          <UitkLayoutFlexItem grow={1} minWidth={minWidth} maxWidth={maxWidth}>
            <UitkCard border={true} padded={true}>
              <UitkHeading tag="h3" size={4}>
                <LocalizedText message="lp.affiliate.benefits.commission.title" />
              </UitkHeading>
              <UitkText spacing="four">
                <LocalizedText message="lp.affiliate.benefits.commission.text1" />
              </UitkText>
              <UitkText spacing="four">
                <LocalizedText message="lp.affiliate.benefits.commission.text2" />
              </UitkText>
            </UitkCard>
          </UitkLayoutFlexItem>
          <UitkLayoutFlexItem grow={1} minWidth={minWidth} maxWidth={maxWidth}>
            <UitkCard border={true} padded={true}>
              <UitkHeading tag="h3" size={4}>
                <LocalizedText message="lp.affiliate.benefits.inventory.title" />
              </UitkHeading>
              <UitkText spacing="four">
                <LocalizedText message="lp.affiliate.benefits.inventory.text" />
              </UitkText>
              <UitkSpacing className="uitk-type-list-400" padding={{ block: 'three', inline: 'four' }}>
                <UitkList>
                  <UitkListItem key="listitem-1-1"><LocalizedText message="lp.affiliate.benefits.car.inventory.text" /></UitkListItem>
                  <UitkListItem key="listitem-1-2"><LocalizedText message="lp.affiliate.benefits.hotel.inventory.text" /></UitkListItem>
                  <UitkListItem key="listitem-1-3"><LocalizedText message="lp.affiliate.benefits.activities.inventory.text" /></UitkListItem>
                  <UitkListItem key="listitem-1-4"><LocalizedText message="lp.affiliate.benefits.airlines.inventory.text" /></UitkListItem>
                </UitkList>
              </UitkSpacing>
            </UitkCard>
          </UitkLayoutFlexItem>
          <UitkLayoutFlexItem grow={1} minWidth={minWidth} maxWidth={maxWidth}>
            <UitkCard border={true} padded={true}>
              <UitkHeading tag="h3" size={4}>
                <LocalizedText message="lp.affiliate.benefits.tools.title" />
              </UitkHeading>
              <UitkText spacing="four">
                <LocalizedText message="lp.affiliate.benefits.tools.text1" />
              </UitkText>
              <UitkText spacing="four">
                <LocalizedText message="lp.affiliate.benefits.tools.text2" />
              </UitkText>
            </UitkCard>
          </UitkLayoutFlexItem>
        </UitkLayoutFlex>
        <UitkText align="center">
          <AffiliateCTA locale={this.props.locale} />
        </UitkText>
      </>
    );

    return (
      <Viewport>
        <ViewSmall>{getContent('column', 'full_width', 'full_width')}</ViewSmall>
        <ViewMedium>{getContent('row', 'third_width', 'third_width')}</ViewMedium>
      </Viewport>
    );
  }
}
